(function ($){
	jQuery(function() {
		$(".slideset").bxSlider({
			controls:false,
			pager: true,
			pagerCustom: '#bx-slider-pager',
			touchEnabled: false,
			auto: true,
			pause: 8000
		});

		$('.image-carousel').bxSlider({
			controls:false,
			pager: true,
			touchEnabled: false
		});

		$(".filter-holder form select").change(function(){
			$(this).parents('form').submit();
		});
	} );
})(jQuery);